import Form from 'components/Profile/Preferences/Form';
import ViewGate from 'components/Profile/View/Gate';

const Preferences = () => {
  return (
    <ViewGate stepId="preferences">
      {(editProps) => <Form {...editProps} />}
    </ViewGate>
  )
}

export default Preferences;
